import React from 'react'
import styled from '@emotion/styled'
import { useRouter } from 'next/router'
import { mq, createBugsnagErrorBoundary } from '../../../helpers'
import { Header2, Header3, Text } from '../../../styles/Components'
import { popularServices as popularServicesFn } from './data'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Pagination } from 'swiper/modules'

// Fixes the historical copy-paste bug where this boundary was labeled 'Quotes'.
const ServicesBugsnagErrorBoundary = createBugsnagErrorBoundary('Services')

const ServicesWrapper = styled.div`
  width: 100%;
  max-width: 1600px;
  display: flex;
  flex-direction: column;
  padding: 50px 88px;

  ${mq('max', '768px')} {
    padding: 38px 16px;
  }

  .web-carousel-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    ${mq('max', '768px')} {
      display: none;
    }
  }
  .mobile-carousel-container {
    width: 100%;
    display: flex;
    flex-direction: row;

    ${mq('min', '768px')} {
      display: none;
    }

    .swiper-pagination-bullet {
      height: 12px;
      width: 12px;
      border-radius: 50%;
      background-color: transparent;
      border: 1px solid #3f3f3f;
      bottom: 0;
    }

    .swiper-pagination-bullet-active {
      height: 12px;
      width: 12px;
      border-radius: 50%;
      background-color: #000;
      border: 1px solid #000;
    }
  }

  .carousel-service-card {
    border: none;
    background-color: transparent;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .card-inner {
      align-items: flex-start;

      p {
        text-align: left;
      }
    }

    ${mq('max', '768px')} {
      margin-bottom: 48px;
    }
  }
`

const ServicesSection = () => {
  const router = useRouter()

  const redirectToBook = ({ serviceType, name }) =>
    router.push(`/book/?stp=${serviceType}&svc=${name.toLowerCase()}`)

  const popularServices = popularServicesFn(redirectToBook)

  return (
    <ServicesWrapper>
      <Header2 margin='0 0 24px 0'>
        Five-star beauty services
      </Header2>
      <div className='web-carousel-container'>
        {popularServices.map((s, i) => (
          <div key={i} className='carousel-service-card' onClick={s.clickHandler} role='button'>
            <div className='card-inner'>
              <Header3 margin='0 0 12px 0'>
                {s.title}
              </Header3>
              <Text margin='0 0 8px 0'>
                Starting at ${s.price}
              </Text>
              <Text margin='0 0 44px 0'>
                {s.description}
              </Text>
            </div>
            {s.image()}
          </div>
        ))}
      </div>
      <div className='mobile-carousel-container'>
        <ServicesBugsnagErrorBoundary>
          <Swiper
            modules={[Pagination]}
            spaceBetween={47}
            slidesPerView={1.3}
            pagination={{ clickable: true, dynamicBullets: false }}
          >
            {popularServices.map((s, i) => (
              <SwiperSlide key={i}>
                <div className='carousel-service-card' onClick={s.clickHandler} role='button'>
                  <div>
                    <Header3 margin='0 0 12px 0'>
                      {s.title}
                    </Header3>
                    <Text margin='0 0 8px 0'>
                      Starting at ${s.price}
                    </Text>
                    <Text margin='0 0 44px 0'>
                      {s.description}
                    </Text>
                  </div>
                  {s.image()}
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </ServicesBugsnagErrorBoundary>
      </div>
    </ServicesWrapper>
  )
}

export default ServicesSection
